export default class UserRoleData {
    public id: number;
    public key: string;
    public name: string;
    public description: string;
    public isStaff: boolean;
    
    constructor(
        id: number,
        key: string,
        name: string,
        description: string,
        isStaff: boolean,
    ) {
        this.id = id;
        this.key = key;
        this.name = name;
        this.description = description;
        this.isStaff = isStaff;
    }
}
